/* unplugin-vue-components disabled */import script from "./LangSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./LangSelect.vue?vue&type=script&setup=true&lang=js"

import "./LangSelect.vue?vue&type=style&index=0&id=54f35451&lang=less"

const __exports__ = script;

export default __exports__